import { ICurrentAgendaIndex } from '../../page/page-storage/agenda-items/agenda-items.types';
import { IAgendaItem } from '../../resource/agenda-item/agenda-item.types';
import { IMeetingSimple } from '../../resource/meeting-simple/meeting-simple.types';
import { IApiRequestConfig } from '../api.types';

export const getAgendaItemsApi = (meetingId?: IMeetingSimple['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getAgendaItemsApi',
  uri: 'json',
  action: 'getMeetingAgendaItems',
  method: 'get',
  params: {
    meetingId,
  },
});

export const saveAgendaItemsApi = (
  meetingId: IMeetingSimple['id'],
  agendaItems: IAgendaItem[],
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'saveAgendaItemsApi',
  uri: 'json',
  action: `meetings/${meetingId}/agenda-items`,
  method: 'put',
  data: {
    agendaItems,
  },
  v2: true,
});

export const moveStepAgenda = (params: ICurrentAgendaIndex): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'moveStepAgendaApi',
  uri: 'json',
  action: 'moveStepAgenda',
  method: 'post',
  params: {
    ...params,
  },
});
